import { ParameterContainer, ParameterDefinition, ParameterValue } from '@barthauer/abc/queries/parameters/core';

export class MapViewDefinition {
  selectionColor: number[]; //TODO: How to?
  extent: number[];
  projection: string;
}

export class Map {
  view: MapViewDefinition;
  projections: MapProjection[];
  layers: MapLayer[];
  overviewLayers: MapLayer[];
  scales: number[];
  dataSources: MapDataSource[];
  target: MapTarget;
}

export class MapProjection {
  name: string;
  definition: string;
}

export enum MapLayerType {
  Group,
  ObjectSpace,
  OSM,
  Raster,
  GeoTIFF,
  XYZ,
  WMS,
  WMTS,
  Shp,
  Dbms,
}

export class MapLayer {
  type: string;
  name: string;
  fullName: string;
  displayText: string;
  visible: boolean;
  visibleInLegend: boolean;
  selectable: boolean;
  minScale: number;
  maxScale: number;
  minScaleSizing: number;
  maxScaleSizing: number;
  opacity: number;
  zIndex: number;
  projection: string;
  query: any;
  layers: MapLayer[];
  partitionColumnName: string | string[];
  identityColumnName: string;
  style: MapStyle[];
  dataSource: string;
  loginName: string;
  password: string;
  objectClassName: string;
  filter: string;
  layerNames: string[];
  crossOrigin: string;
  minZoom: number;
  maxZoom: number;
  url: string;
  webApiUrl: string;
  webApiTilesName: string;
  copyright: string;
  columns: MapLayerColumn[];
  layerName: string;
  matrixSetName: string;
  styleName: string;
  target: MapTarget;
}

export class MapLayerColumn {
  name: string;
  displayName: number;
  useForTooltip: number;
  useForExpression: number;
}

export class MapTarget {
  name: string;
  url: string;
}

export class MapStyle {
  partition: string | string[][];
  displayText: string;
  svgPreviewShapes: string;
  zIndex: number;
  minScaleSizing: number;
  maxScaleSizing: number;
  fill: MapStyleFill;
  image: MapStyleImage;
  stroke: MapStyleStroke;
  text: MapStyleText;
}

export class MapStyleFill {
  color: MapStyleValue<number[]>;
  isInvisible: MapStyleValue<boolean>;
}

export class MapStyleImage {
  anchor: MapStyleValue<number[]>;
  anchorOrigin: MapStyleValue<string>;
  anchorXUnits: MapStyleValue<string>;
  anchorYUnits: MapStyleValue<string>;
  color: MapStyleValue<number[]>;
  displacement: MapStyleValue<number[]>;
  isInvisible: MapStyleValue<boolean>;
  crossOrigin: MapStyleValue<string>;
  offset: MapStyleValue<number[]>;
  offsetOrigin: MapStyleValue<string>;
  opacity: MapStyleValue<number>;
  offsetX: MapStyleValue<number>;
  offsetY: MapStyleValue<number>;
  scale: MapStyleValue<number>;
  snapToPixel: MapStyleValue<boolean>;
  rotateWithView: MapStyleValue<boolean>;
  rotation: MapStyleValue<number>;
  size: MapStyleValue<number[]>;
  imgSize: MapStyleValue<number[]>;
  imgFactor: MapStyleValue<number>;
  src: MapStyleValue<string>;
}

export class MapStyleStroke {
  color: MapStyleValue<number[]>;
  isInvisible: MapStyleValue<boolean>;
  lineCap: MapStyleValue<string>;
  lineJoin: MapStyleValue<string>;
  lineDash: MapStyleValue<number[] | { dashsAndGaps: number[]; shapeIdentifiers: string[]; transparency: number }>;
  lineDashOffset: MapStyleValue<number>;
  miterLimit: MapStyleValue<number>;
  width: MapStyleValue<number>;
}

export class MapStyleText {
  font: MapStyleValue<string>;
  offsetX: MapStyleValue<number>;
  offsetY: MapStyleValue<number>;
  scale: MapStyleValue<number>;
  rotateWithView: MapStyleValue<boolean>;
  rotation: MapStyleValue<number>;
  text: MapStyleValue<string>;
  textAlign: MapStyleValue<string>;
  textBaseline: MapStyleValue<string>;
  fill: MapStyleFill;
  stroke: MapStyleStroke;
  declutterGroupColumnName: string;
  declutterCategoryName: string;
  declutterMaxDistance: number;
  declutterMinScale: number;
}

export class MapStyleValue<T> {
  value: T;
  valueColumnNames: string[];
  valueMap: string[][];
  valueTransformType: string;
}

export class MapDataSource implements ParameterContainer {
  name: string;
  useCurrentDataStore: boolean;
  ParameterDefinitions: ParameterDefinition[];
  Parameters: ParameterValue[];
}
